import { Chip } from '@mui/material'
import { ICONE } from 'icons'
import { BaseHeaderConIcona } from 'layout'
import { creaLabelUtente } from './utilPermessiEntita'

export default function HeaderUtente(props) {
  const { utente, labelCreatore, ...restProps } = props

  return (
    <BaseHeaderConIcona
      icona={<ICONE.PERSONA />}
      titolo={creaLabelUtente(utente)}
      sottotitolo={
        <>
          {utente.info.nickname}
          {utente.isCreatore &&
            <>
              <br/>
              <Chip
                label={labelCreatore || 'Creatore'}
                color='warning'
                size='small'
              />
            </>
          }
        </>
      }
      {...restProps}
    />
  )
}
